'use client';
import { lazy, type ComponentProps } from 'react';
export type * from "/tmp/build-401/overrides/components/categories/category-filter-left.tsx";
const Deferred0 = lazy(() => import("@eliadmin/page-island-original/2cfb82df4615").then(m => ({ default: m.CategoryFilterLeft })));
const Island0 = ((props: NonNullable<ComponentProps<typeof import("/tmp/build-401/overrides/components/categories/category-filter-left.tsx").CategoryFilterLeft>>) => <Deferred0 {...props} />) as typeof import("/tmp/build-401/overrides/components/categories/category-filter-left.tsx").CategoryFilterLeft;
export { Island0 as CategoryFilterLeft };
